import { styled, css } from 'styled-components';

export const ListContainer = styled.div`
  ${({ theme: { spacings } }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;

    padding: ${spacings.s24} 0 ${spacings.s24};
  `}
`;

export const ListRow = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    align-items: baseline; /* was center — aligns text baselines across the two fonts */
    justify-content: space-between;
    gap: 0.75rem;
    border-bottom: 1px solid ${colors.brandDarkTint90};
    padding: 0.75rem 0;
    line-height: 1.2;

    flex-grow: 1;
    flex-basis: 0;
    align-items: center;

    &:last-child {
      border-bottom: none;
    }
  `}
`;

export const ListLabel = styled.span`
  ${({ theme: { colors } }) => css`
    font-size: 0.75rem;
    color: ${colors.brandDarkTint20};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;

export const ListValue = styled.span`
  ${({ theme: { colors, fontWeights } }) => css`
    font-weight: ${fontWeights.semiBold};
    font-size: 0.75rem;
    color: ${colors.brandDark};
    white-space: nowrap;
    text-align: right;
    flex-shrink: 0;
  `}
`;

export const EmptyState = styled.p`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkAlpha50};
    text-align: center;
  `}
`;
